module.exports = __webpack_public_path__ + "static/media/emailIcon.38be8da8.svg";